
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[city]",
      function () {
        return require("private-next-pages/c/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[city]"])
      });
    }
  